/*
 * @Author: lihaitao
 * @Date: 2020-05-13 14:11:03
 * @Last Modified by: lihaitao
 * @Last Modified time: 2020-06-01 17:56:09
 */
import DsCloud from '@markting/ds-cloud'
interface Config {
  type: string;
  region: string;
  accessKeyId: string;
  accessKeySecret: string;
  stsToken: string;
  bucket: string;
  secure: boolean;
  key: string;
  startTime: number;
  expiredTime: number;
  isDownLoad: boolean;
  headers: any;
  expiration: string;
}

interface Options {
  config: Config;
  success: Function;
  fail: Function;
  progress: Function;
}

// 获取文件后缀名
export function getFileSuffix (name: string) {
  const index = name.lastIndexOf('.')
  const suffix = name.substr(index).toLocaleLowerCase()
  return suffix || ''
}

// 生成下载文件名设置
export function getAttachmentFileName (file: File) {
  const index = file.name.lastIndexOf('.')
  const name = file.name.substr(0, index)
  // 名称长度截取前20
  const fName = name.slice(0, 20)
  const suffix = getFileSuffix(file.name)
  // 若filename中带有,，则会使下载失败
  let fileName = fName + suffix
  fileName = fileName.replace(/,/g, '-')
  return fileName
}

// 获取文件上传路径，对象 key 值
// function getKey (path: string, name: string) {
//   return `/${path}/${name}`
// }

function getContentDisposition (file: File) {
  const index = file.name.lastIndexOf('.')
  const name = file.name.substr(0, index)
  // 名称长度截取前20
  const fName = name.slice(0, 20)
  const suffix = getFileSuffix(file.name)
  // 若filename中带有,，则会使下载失败
  let fileName = fName + suffix
  fileName = fileName.replace(/,/g, '-')
  return `attachment;filename=${encodeURI(fileName)}`
}

function handleHeaders (headers: any, file: File, isDownLoad: boolean) {
  if (isDownLoad) {
    headers['Content-Disposition'] = getContentDisposition(file)
  }
  return headers
}

function mapTypeToRegion (type: string) {
  const types: any = {
    cos: 'ap-shanghai',
    oss: 'oss-cn-hangzhou'
  }
  return types[type]
}

export function generateRandomFileName (file: File) {
  return Math.random()
    .toString(36)
    .substring(2) +
          new Date().getTime() +
          getFileSuffix(file.name)
}

/**
 *  上传方法，初始化 DsCloud
 * @param file 文件
 * @param options 上传配置
 */
export async function uploadDustessCloud (file: File, options: Options) {
  try {
    const {
      config: {
        type,
        key,
        isDownLoad,
        headers,
        accessKeyId,
        accessKeySecret,
        stsToken,
        bucket,
        secure,
        startTime,
        expiredTime,
        expiration
      }
    } = options
    const currentHeaders = handleHeaders(headers, file, isDownLoad)
    const client = new DsCloud({
      type,
      region: mapTypeToRegion(type),
      accessKeyId,
      accessKeySecret,
      stsToken,
      bucket,
      key,
      secure,
      startTime,
      expiredTime,
      expiration,
      headers: currentHeaders
    })
    const res = await client.multipartUpload(file, {
      progress: (percent: number) => {
        options.progress({
          type: 'progress',
          result: { progress: percent },
          file: file
        })
      }
    })
    options.success({
      type: 'success',
      result: res,
      file: file
    })
  } catch (error) {
    console.log(error)
    options.fail({
      type: 'fail',
      result: error,
      file: file
    })
  }
}
